import type { CustomFlowbiteTheme } from 'flowbite-react';

export const navbarTheme: CustomFlowbiteTheme['navbar'] = {
  root: {
    base: 'bg-white sm:px-16 sm:py-6 border-b border-gray-200',
    rounded: {
      on: 'rounded',
      off: '',
    },
    bordered: {
      on: 'border',
      off: '',
    },
    inner: {
      base: 'mx-auto flex flex-wrap items-center justify-between',
      fluid: {
        on: '',
        off: 'container',
      },
    },
  },
  brand: {
    base: 'flex items-center px-2 py-4 ',
  },
  collapse: {
    base: 'w-full md:block md:w-auto',
    list: 'mt-4 flex flex-col md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium',
    hidden: {
      on: 'hidden',
      off: '',
    },
  },
  link: {
    base: 'block py-2 pl-3 pr-4 text-gray-900 md:p-0',
    active: {
      on: 'text-titan-night-900 bg-transparent font-bold md:bg-transparent',
      off: 'text-titan-night-900 hover:bg-titan-night-100 md:hover:text-titan-night-700 md:hover:bg-transparent',
    },
    disabled: {
      on: 'text-titan-night-400 hover:cursor-not-allowed',
      off: '',
    },
  },
  toggle: {
    base: 'text-titan-night-500 hover:bg-titan-night100 inline-flex items-center p-2 text-sm focus:outline-none focus:ring md:hidden',
    icon: 'h-6 w-6 shrink-0',
  },
};
